<template>
    <div class="data">
        <div class="opt_path mb20">
            <span @click="$router.push({ path: `/courseware` })">教学课件</span>
            <span>数据分析</span>
        </div>
        <div class="ls_flexalign_center race_countObj">
            <div>
                <div>{{ countObj.title }}</div>
                <div>面向标签：{{ countObj.groupNames }}</div>
                <div>发布时间：{{ countObj.publishTime }}</div>
            </div>
            <div class="ls_flex_1"></div>
            <div class="ls_flexalign_center">
                <div>
                    <div>{{ countObj.completeNumber }}</div>
                    <div>查看人数</div>
                </div>
                <div>
                    <div>{{ countObj.totalLearnTime }}</div>
                    <div>查看时长</div>
                </div>
            </div>
        </div>
        <div class="ls_flexalign_center search_part">
            <el-select v-model="params.learnStatus" size="medium">
                <el-option v-for="item in statusOptions" :key="item.label" :label="item.label" :value="item.value" />
            </el-select>
            <el-input v-model.trim="params.studentUserName" size="medium" placeholder="请输入姓名" style="width: 300px;"></el-input>

            <el-button size="medium" plain @click="(params.pageIndex = 1), getList()">
                查询
            </el-button>
            <div class="ls_flex_1"></div>
        </div>

        <el-table :data="list" highlight-current-row :header-cell-style="{ background: '#FAFAFA' }" style="width: 100%" @sort-change="sort">

            <el-table-column label="用户">
                <div class="ls_flexalign_center" slot-scope="scope">
                    <img :src="scope.row.avatar | imgFormat" style="height: 60px;width: 60px;margin-right: 10px;" />
                    <span>{{ scope.row.studentUserName }}</span>
                </div>
            </el-table-column>
            <el-table-column label="班级">
                <div class="ls_flexalign_center" slot-scope="scope">
                    <span>{{ scope.row.groupName }}</span>
                </div>
            </el-table-column>
            <el-table-column label="查看时长">
                <template slot-scope="scope">
                    {{ scope.row.learnTime ? "累计查看" + scope.row.learnTime + "分钟" : "-" }}
                </template>
            </el-table-column>
            <el-table-column label="最近一次查看">
                <template slot-scope="scope">
                    {{ scope.row.updateTimeStr || "-" }}
                </template>
            </el-table-column>
        </el-table>
        <div class="page_part">
            <el-pagination v-if="total" :current-page.sync="params.pageIndex" :page-sizes="[10, 15, 20, 25]" :page-size.sync="params.pageSize" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="getList" @current-change="getList" />
        </div>
    </div>
</template>

<script>
export default {

    data () {
        return {
            params: {
                id: this.$route.query.id,
                learnStatus: "", // 学习状态 0-未学习 1-已学习
                studentUserName: "", // 学生用户名称

                pageIndex: 1,
                pageSize: 10,
            },
            total: 0,
            statusOptions: [
                { value: '', label: "全部" },
                { value: 0, label: "未学习" },
                { value: 1, label: "已学习" },
            ],
            countObj: {},
            list: [],
        };
    },
    created () {
        this.getList();
        this.getcountObj();
    },
    methods: {
        sort (e) {
            this.params.sort = e.order;
            this.params.pageIndex = 1;
            this.getList();
        },
        getList () {
            this.$ajax.post("/coursewareOrganization/analyseList", {
                ...this.params,
            }).then(response => {
                this.list = response.list;
                this.total = response.total;
            });
        },
        getcountObj () {
            this.$ajax.get("/coursewareOrganization/analyseHead", {
                params: { id: this.$route.query.id }
            }).then(response => {
                this.countObj = response.data;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.data {
    padding-top: 20px;
    padding-right: 30px;
}

.race_countObj {
    margin-bottom: 30px;

    >div {
        &:first-child {
            width: 500px;

            >div {
                &:first-child {
                    font-size: 26px;
                    margin-bottom: 20px;
                }

                &:last-child {
                    margin-top: 20px;
                    font-size: 16px;
                    color: #999;
                }
            }
        }

        &:last-child {
            >div {
                text-align: center;
                padding: 0 30px;

                +div {
                    border-left: 1px solid rgb(202, 202, 202);
                }

                >div {
                    &:first-child {
                        font-size: 16px;
                    }

                    &:last-child {
                        font-size: 16px;
                        color: #999;
                        margin-top: 10px;
                    }
                }
            }
        }
    }
}

.search_part {
    >* {
        +* {
            margin-left: 7px;
        }

        &:first-child(1),
        &:nth-child(2) {
            width: 120px;
        }

        &:nth-child(3) {
            width: 200px;
        }

        &:nth-child(6) {
            width: 220px;
        }
    }

    margin-bottom: 15px;
}

.page_part {
    text-align: center;
    margin-top: 20px;
}
</style>
